const colors = require('tailwindcss/colors');

export const themeLight = {
  theme: 'light',
  background: 'bg-white',
  mainBackground: 'bg-white',
  logo: 'text-black',
  dropdown: {
    background: 'bg-white',
    shadow: '#F1F5F9',
    backgroundSolutions: 'bg-neutral-100',
    backgroundBottomMobile: 'bg-neutral-200',
    border: 'border-neutral-200',
    title: 'text-neutral-600',
    items: {
      icon: 'bg-menu-icon-gradient',
      solid: {
        icon: 'bg-neutral-400'
      },
      title: 'text-black',
      text: 'text-neutral-400'
    },
    caret: {
      background: '#ffffff',
      border: '#F1F5F9'
    }
  },
  closeButton: {
    cross: colors.black,
    background: 'bg-blue-neutral-200'
  },
  rapid: {
    background: 'bg-white',
    text: 'text-black',
    gradient: true
  },
  labeled: 'bg-black text-white'
};

export const themeDark = {
  theme: 'dark',
  background: 'bg-neutral-900',
  mainBackground: 'bg-black',
  logo: 'text-white',
  dropdown: {
    background: 'bg-neutral-900',
    shadow: '#262626',
    backgroundSolutions: 'bg-neutral-800',
    backgroundBottomMobile: 'bg-neutral-800',
    border: 'border-neutral-800',
    title: 'text-neutral-400',
    items: {
      icon: 'bg-menu-icon-gradient',
      solid: {
        icon: 'bg-neutral-800'
      },
      title: 'text-white',
      text: 'text-neutral-400'
    },
    caret: {
      background: '#171717',
      border: '#262626'
    }
  },
  closeButton: {
    cross: colors.white,
    background: 'bg-neutral-600'
  },
  rapid: {
    background: 'bg-neutral-900',
    text: 'text-white',
    gradient: true
  },
  labeled: 'bg-white text-black'
};

export const themeMixed = {
  theme: 'dark',
  background: 'bg-neutral-900',
  logo: 'text-black',
  dropdown: {
    background: 'bg-neutral-900',
    shadow: '#262626',
    backgroundSolutions: 'bg-neutral-800',
    backgroundBottomMobile: 'bg-neutral-800',
    border: 'border-neutral-800',
    title: 'text-neutral-400',
    items: {
      icon: 'bg-menu-icon-gradient',
      solid: {
        icon: 'bg-neutral-800'
      },
      title: 'text-white',
      text: 'text-neutral-400'
    },
    caret: {
      background: '#171717',
      border: '#262626'
    }
  },
  closeButton: {
    cross: colors.white,
    background: 'bg-neutral-600'
  },
  rapid: {
    background: 'bg-neutral-900',
    text: 'text-white',
    gradient: true
  },
  labeled: 'bg-white text-black'
};

export default themeLight;
